import moment from 'moment';

import {
  getReceivedAddOns,
  getReceivedParticipant,
  getReceivedSchedule,
  getReceivedMandatoryFees
} from 'utils/book-accommodation-and-activity/prepareReceivedDataMethods';
import { getPrices as getActivityPrices } from 'utils/accommodations-and-activities/prepareReceivedActivityData';
import { getParticipants as getActivityParticipants } from 'utils/book-activity/prepareParticipants';
import { getPrices as getAccommodationPrices } from 'utils/accommodations-and-activities/prepareReceivedAccommodationData';
import { getParticipants as getAccommodationParticipants } from 'utils/book-accommodation/prepareParticipants';

const FIXED_PRICES = 'pricesFixedForm';
const CATEGORY_PRICES = 'pricesCategoryForm';
const DAILY_PRICES = 'pricesDailyForm';
const FUTURE_PRICES = 'futurePricesForm';

const getReceivedBookedActivityData = data => {
  const payment = data.payments[0];
  const currency = payment.currency.currency;

  const startingDate = data.startingDate
    ? moment(data.startingDate, 'YYYY-MM-DD')
    : null;

  const endingDate = data.endingDate
    ? moment(data.endingDate, 'YYYY-MM-DD')
    : null;
    
  const pricesObj = getActivityPrices(data.activity);
  const activity = {
    ...data.activity,
    ...pricesObj
  };
  const participantData = {
    values: { currency: currency, startingDate: startingDate }
  };

  const activityParticipants = getActivityParticipants(
    activity,
    participantData,
    () => {},
    false
  );

  const dates = {};

  if (startingDate && endingDate) {
    dates.multiDates = {
      startDate: startingDate,
      endDate: endingDate
    };
    dates.startingDate = startingDate;
  } else {
    dates.startingDate = startingDate;
  }

  return {
    id: parseInt(data.id),
    activityId: parseInt(data.activity.id),
    firstName: data.guestFirstName,
    lastName: data.guestLastName,
    phone: data.guestPhoneNumber,
    email: data.guestEmail,
    platform: data.platform,
    pay: {
      'Pay on arrival': true
    },
    currency: currency,
    paymentId: parseInt(payment.id),
    addOns: getReceivedAddOns(data.bookedAddOns),
    participants: getReceivedParticipant(
      data.guests,
      currency,
      activityParticipants
    ),
    ...getReceivedSchedule(data.schedule),
    accommodations: _getReceivedRelatedAccommodations(
      data.relatedAccommodationBooking,
      currency
    ),
    ...dates
  };
};

const _getReceivedRelatedAccommodations = (
  relatedAccommodationBooking,
  currency
) => {
  return relatedAccommodationBooking.map(item => {
    const payment = item.payments[0];

    const pricesObj = getAccommodationPrices(item.accommodation);
    let accommodation = {
      ...item.accommodation,
      ...pricesObj
    };
    
     let basePricesType = FIXED_PRICES;

     if (accommodation.prices[0].participant.participant) {
      basePricesType = CATEGORY_PRICES;
    } else if (accommodation.prices[0].day) {
      basePricesType = DAILY_PRICES;
    }

    accommodation['basePricesType'] = basePricesType;
    
     if (accommodation.futurePrices?.[0]?.ratePlanPrices) {
       accommodation['pricesType'] = FUTURE_PRICES;
     } else {
       accommodation['pricesType'] = basePricesType;
     }

    const dates = {
      startDate: moment(item.fromDate, 'YYYY-MM-DD'),
      endDate: moment(item.toDate, 'YYYY-MM-DD')
    };

    const accommodationParticipants = getAccommodationParticipants(
      accommodation,
      currency,
      null,
      dates
    );

    const norwegianFields = {};
    if (item.accommodation.titleNo) {
      norwegianFields.title = item.accommodation.titleNo;
    }

    return {
      id: parseInt(item.id),
      accommodation: parseInt(item.accommodation.id),
      pricesType: accommodation.pricesType,
      title: item.accommodation.title,
      Norwegian: norwegianFields,
      platform: item.platform,
      currency: currency,
      paymentId: parseInt(payment.id),
      dates: dates,
      addOns: getReceivedAddOns(item.bookedAddOns),
      mandatoryFees:getReceivedMandatoryFees(item.bookedMandatoryFees),
      participants: getReceivedParticipant(
        item.guests,
        currency,
        accommodationParticipants
      )
    };
  });
};

export { getReceivedBookedActivityData };
